export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/imageWorker.worker.c6d71830.worker.js");
}
